import { callApi } from '@/api/apibase'

export const getGreenCourseSettings = function () {

  return callApi('GET', '/api/external/greencourse/settings', null)
}
